import React, { useContext } from "react";
import { BooleanInput, CheckboxGroupInput, Edit, FormTab, TabbedForm, TextInput } from "react-admin";
import MaskedInput from "../../components/masked-input";
import TextFieldWithClipboardButton from "../../components/text-field-with-clipboard-button";
import { AppContext } from "../../providers/app-context-provider/app.context";
import { storageProvider } from '../../providers/storage-provider';

const InstitutionEdit = (props) => {

  const CustomTitle = ({ record }) => {
    return <span> {record.name} </span>
  }

  const superAdmin = storageProvider.getCurrentUser()?.superAdmin
  const context = useContext(AppContext)

  const product = context.product;

  return (
    <Edit
      mutationMode="pessimistic"
      title={<CustomTitle />}
      {...props}
    >
      <TabbedForm>
        <FormTab label={'Dados Gerais'}>
          <TextInput source="name" label={'Nome'} fullWidth disabled={!superAdmin} />
          <TextInput source="slug" label={'slug'} fullWidth disabled={!superAdmin} />
          <MaskedInput source="cnpj" onlyNumbers={true} mask={'99.999.999/9999-99'} label={'CNPJ'} fullWidth disabled={!superAdmin} />
          {superAdmin && <BooleanInput source="active" label={'Ativa'} fullWidth />}
          {product.id === 1 && (superAdmin ?
            <TextInput source="video_room" label={'Link da sala de audiência no metaverso'} fullWidth />
            : <TextFieldWithClipboardButton label={'Link da sala de audiência no metaverso'} source="video_room" fullWidth />)}
          {product.id === 2 && <TextFieldWithClipboardButton label={'Link para comunicação externa com o correio do atendimento'} url={'https://app.juristta.com/#/external-process-mail'} sourceless={true} />}
        </FormTab>

        {
          superAdmin && <FormTab label={'Módulos'} path="products">
            <CheckboxGroupInput
              source="products"
              label="Módulos que a instituição pode acessar"
              variant="filled"
              choices={[{ id: 1, name: 'Juristta School' }, { id: 2, name: 'Juristta Office' }]}
              optionText="name"
              optionValue="id"
              fullWidth
              parse={value =>
                value && value.map(v => ({ id: v }))
              }
              format={value => value && value.map(v => v.id)}
            />
          </FormTab>
        }
        <FormTab label={'Notificações e email'}>
          <BooleanInput source="sendMailToManagerOnAdd" label={'Enviar email automaticamente ao adicionar um gestor a um atendimento'} fullWidth />
          <BooleanInput source="sendMailToManagerOnRemove" label={'Enviar email automaticamente ao remover um gestor a um atendimento'} fullWidth />
          <BooleanInput source="sendMailToStudentOnAdd" label={'Enviar email automaticamente ao adicionar um aluno a uma movimentação'} fullWidth />
          <BooleanInput source="sendMailToStudentOnRemove" label={'Enviar email automaticamente ao remover um aluno a uma movimentação'} fullWidth />
        </FormTab>
      </TabbedForm>
    </Edit>
  )
}
export default InstitutionEdit;
